import { BackLink } from "components/base/BackButton";
import { useSearchParams } from "react-router-dom";

const NavigationBar = ({
  leftButtons,
  rightButtons,
  backTo,
  title,
  subtitle = null,
  prompt,
  testing,
  testingMessage = "We are testing this page/feature. If you have any feedback, please contact us.",
}) => {
  const [searchParams] = useSearchParams();

  // build search params for url from state object

  let params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  const currentSearchString = new URLSearchParams(params).toString();
  const shouldAppendCurrentSearch =
    Boolean(currentSearchString) &&
    typeof backTo === "string" &&
    !backTo.includes("?");
  const finalBackto = shouldAppendCurrentSearch
    ? `${backTo}?${currentSearchString}`
    : backTo;

  return (
    <nav className="bg-gray-50 dark:bg-gray-900 flex flex-col lg:flex-row lg:justify-between lg:items-center border-b dark:border-gray-700 sticky top-0 backdrop-filter backdrop-blur-lg bg-opacity-60 dark:bg-opacity-80 z-20 py-3 overflow-auto flex-shrink-0">
      <div className={finalBackto ? "flex items-center min-w-0" : "min-w-0"}>
        <div className="flex items-center">
          {finalBackto && (
            <div className="px-4 opacity-50 hover:opacity-100">
              <BackLink to={finalBackto} />
            </div>
          )}
        </div>

        {title ? (
          <div className={finalBackto ? "min-w-0 flex-1" : "px-6 min-w-0"}>
            <div className="font-bold break-words text-lg">
              {title}
              {testing ? (
                <div className="text-sm text-pink-600">{testingMessage}</div>
              ) : null}
            </div>
            {subtitle && <div className={`mt-1 break-words`}>{subtitle}</div>}
          </div>
        ) : null}

        {leftButtons ? (
          <div
            className={`pl-4 lg:pl-6 flex items-center whitespace-nowrap
           ${title ? " mt-1" : ""}
        `}
          >
            {leftButtons}
          </div>
        ) : null}
      </div>

      <div className="space-y-2 overflow-hidden mt-2 lg:mt-0 self-end lg:self-auto">
        {prompt ? prompt : null}
        {rightButtons ? (
          <div className="px-6 lg:px-6 animate-fadeInRight opacity-0 whitespace-nowrap">
            {rightButtons}
          </div>
        ) : null}
      </div>
    </nav>
  );
};

export default NavigationBar;
